/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Extract_Start_LogInputs */

const en_drastic_tech_extract_start_log = /** @type {(inputs: Drastic_Tech_Extract_Start_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting extraction process...`)
};

const fr_drastic_tech_extract_start_log = /** @type {(inputs: Drastic_Tech_Extract_Start_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demarrage du processus d'extraction...`)
};

const de_drastic_tech_extract_start_log = /** @type {(inputs: Drastic_Tech_Extract_Start_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraktionsprozess wird gestartet...`)
};

const it_drastic_tech_extract_start_log = /** @type {(inputs: Drastic_Tech_Extract_Start_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvio del processo di estrazione...`)
};

const ru_drastic_tech_extract_start_log = /** @type {(inputs: Drastic_Tech_Extract_Start_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начало процесса экстракции...`)
};

const es_drastic_tech_extract_start_log = /** @type {(inputs: Drastic_Tech_Extract_Start_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando proceso de extracción...`)
};

const zh_cn2_drastic_tech_extract_start_log = /** @type {(inputs: Drastic_Tech_Extract_Start_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始萃取过程……`)
};

const ja_drastic_tech_extract_start_log = /** @type {(inputs: Drastic_Tech_Extract_Start_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抽出プロセスを開始しています...`)
};

const hi_drastic_tech_extract_start_log = /** @type {(inputs: Drastic_Tech_Extract_Start_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निष्कर्षण प्रक्रिया शुरू हो रही है...`)
};

const pt_pt2_drastic_tech_extract_start_log = /** @type {(inputs: Drastic_Tech_Extract_Start_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciando o processo de extração...`)
};

/**
* | output |
* | --- |
* | "Starting extraction process..." |
*
* @param {Drastic_Tech_Extract_Start_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_extract_start_log = /** @type {((inputs?: Drastic_Tech_Extract_Start_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Extract_Start_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_extract_start_log(inputs)
	if (locale === "de") return de_drastic_tech_extract_start_log(inputs)
	if (locale === "it") return it_drastic_tech_extract_start_log(inputs)
	if (locale === "ru") return ru_drastic_tech_extract_start_log(inputs)
	if (locale === "es") return es_drastic_tech_extract_start_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_extract_start_log(inputs)
	if (locale === "ja") return ja_drastic_tech_extract_start_log(inputs)
	if (locale === "hi") return hi_drastic_tech_extract_start_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_extract_start_log(inputs)
	return en_drastic_tech_extract_start_log(inputs)
});